module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "province-F"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tabArea"
  }, [_c('div', {
    staticClass: "seekArea"
  }, [_c('el-input', {
    style: ({
      width: '360px'
    }),
    attrs: {
      "size": "small",
      "placeholder": "省局名称、出版物名称"
    },
    model: {
      value: (_vm.params.keyword),
      callback: function($$v) {
        _vm.$set(_vm.params, "keyword", $$v)
      },
      expression: "params.keyword"
    }
  }), _vm._v(" "), _c('el-select', {
    staticClass: "lnjlClass",
    attrs: {
      "size": "small",
      "placeholder": "历年记录"
    },
    on: {
      "change": _vm.valChange
    },
    model: {
      value: (_vm.selYear),
      callback: function($$v) {
        _vm.selYear = $$v
      },
      expression: "selYear"
    }
  }, _vm._l((_vm.selYearRecord), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  })), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.goSeek
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tabDats,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.$index + 1 + 12 * (_vm.params.no - 1)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sjExamine",
      "label": "省局名称",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "organizationName",
      "label": "出版单位",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "出版物名称",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "100",
      "label": "省局意见",
      "prop": "statussj",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("transStr")(scope.row, "statussj")))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "150",
      "label": "国家新闻出版署意见",
      "prop": "statuszj",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("transZjStr")(scope.row, "statuszj")))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "200",
      "prop": "progress",
      "label": "状态",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.progress == "开始" ? "" : scope.row.progress == "登记" ? "已发布" : scope.row.progress))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "150",
      "label": "操作",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.goFirm(scope.row, 2)
            }
          }
        }, [_vm._v("查看")])]
      }
    }])
  })], 1), _vm._v(" "), (_vm.params.pgAll > 1) ? _c('div', {
    staticClass: "pageCage"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.params.no,
      "layout": "prev, pager, next",
      "page-count": _vm.params.pgAll
    },
    on: {
      "current-change": _vm.pageSent
    }
  })], 1) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ttBar"
  }, [_c('span', [_vm._v("连续型电子出版物出版单位查询")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6801d1b7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/adminRole/successivePressSeek.vue
// module id = 1766
// module chunks = 1